import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../store";

interface IAlert {
  message: string;
  data?: string;
}

const initialState = {
  message: "",
} as IAlert;

export const resetAlertState = createAction("alert/resetState");

export const alertSlice = createSlice({
  name: "alert",
  initialState: initialState,
  reducers: {
    setMessage: (
      state,
      action: PayloadAction<{ message: string; data?: object }>,
    ) => {
      state.message = action.payload.message;

      if (action.payload.data) {
        state.data = JSON.stringify({
          ...action.payload.data,
          message: state.message,
        });
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAlertState, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export const { setMessage } = alertSlice.actions;

export const showSnackbar =
  (message: string, data?: object) => (dispatch: AppDispatch) => {
    dispatch(setMessage({ message, data }));
  };

export default alertSlice.reducer;
